import { UpgradeInclude } from './types';

export const upgradeIncludes: UpgradeInclude[] = [
  {
    title: 'Full Search Results:',
    description: 'View all results and discover key decision-makers.',
  },
  {
    title: 'Enhanced Capabilities:',
    description: 'Export up to 10,000 records at once',
  },
  {
    title: 'Advanced Filters:',
    description: 'Unlock 12 Filters for better Search Results',
  },
];
